import { GoogleLogin } from "@react-oauth/google";
import axios from "axios";
import React from "react";
import { toast } from "react-toastify";
import { devURL } from "../../../utils";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import { login } from "../../../Api";
import { sendAnalyticsEvent } from "../../../analytics";

const GoogleOAuth = () => {
  const navigate = useNavigate();

  const requireReferral = async (credentialResponse) => {
    const { value: referral } = await Swal.fire({
      title: "Do you have a referral?",
      input: "text",
      inputLabel: "ScopeX is under private beta only invited user can register",
      inputPlaceholder: "Enter referral code or SCOPEX23",
      showCloseButton: true,
      confirmButtonText: "Submit",
      confirmButtonColor: "#2878bb",
    });
    if (referral) {
      try {
        const res = await axios.post(`${devURL}/user/auth/google/callback`, {
          ...credentialResponse,
          referral,
        });
        localStorage.setItem("swToken", res.data.token);
        const userInfo = await axios.get(`${devURL}/user/get-user-info`, {
          headers: { token: res.data.token },
        });
        await login(userInfo.data.username);
        localStorage.setItem("SXUser", userInfo.data.full_name);
        sendAnalyticsEvent("sign_up", {
          category: "user",
          action: "google_sign_up",
          label: "user_sign_up",
        });
        if (res.data.token) navigate("/Dashboard");
      } catch (error) {
        if (error.response) {
          toast.error(error.response.data.message);
        } else {
          toast.error("Something went wrong");
          console.error(error);
        }
      }
    }
  };

  const handelSuccess = async (credentialResponse) => {
    try {
      const res = await axios.post(
        `${devURL}/user/auth/google/callback`,
        credentialResponse
      );
      localStorage.setItem("swToken", res.data.token);
      const userInfo = await axios.get(`${devURL}/user/get-user-info`, {
        headers: { token: res.data.token },
      });
      await login(userInfo.data.username);
      localStorage.setItem("SXUser", userInfo.data.full_name);
      sendAnalyticsEvent("login", {
        category: "user",
        action: "google_login",
        label: "user_login",
      });
      if (res.data.token) navigate("/Dashboard");
    } catch (e) {
      if (e.response) {
        // asking for referral can be removed when we don't require referrals
        if (e.response.status === 404) {
          requireReferral(credentialResponse);
        }
        console.log(e.response.data);
      }
      console.log(e);
    }
  };
  return (
    <div className="flex items-center flex-col">
      <GoogleLogin
        text="continue_with"
        onSuccess={handelSuccess}
        onError={() => {
          toast.error("Please try again");
        }}
      />
    </div>
  );
};

export default GoogleOAuth;
